export const COOKIE_PREF_KEY                = "cookiePref"
export const COOKIE_PREF_VALUE_ALL          = "cookiePref-all";
export const COOKIE_PREF_VALUE_ESSENTIAL    = "cookiePref-essential";